import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesDown, faAnglesUp } from '@fortawesome/free-solid-svg-icons';

interface ShowMoreButtonProps {
    showAll: boolean;
    toggleShowAll: () => void;
}

const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ showAll, toggleShowAll }) => {
    
    return (
        <>
            <div className="text-center mt-4 kanit-regular">
                <button className="btn btn-primary" onClick={toggleShowAll}>
                    {showAll ?
                        <>
                            <FontAwesomeIcon icon={faAnglesUp} className="me-2" />
                            Show Less
                        </> :
                        <>
                            <FontAwesomeIcon icon={faAnglesDown} className="me-2" />
                            Show All
                        </>}
                </button>
            </div>
        </>
    );
};

export default ShowMoreButton;

